<template>
  <LuJhu lu-jhu-type="HeShuDanShuangLuJhu" />
</template>

<script>
import LuJhu from '@/components/desktop/common/trend/LuJhu'
export default {
  name: 'HeShuDanShuang',
  components: {
    LuJhu
  }
}
</script>

